/** @jsxImportSource @emotion/react */
import React from 'react';
import { Wrapper, Container, ShellLogoImg } from './registration.styled';
import { ClickableLogo, LogoWrapper } from './shared.styled';
import logoLight from '/main-logo-white.svg';
import logoDark from '/main-logo-white.svg';
import { Install } from './pages/install/install';

const ShellLogo = ({ isLight, small }: { isLight: boolean; small: boolean }) => {
  return (
    <ClickableLogo data-testid="onboarding-logo">
      <LogoWrapper data-testid="onboarding-logo-wrapper">
        <ShellLogoImg
          src={isLight ? logoDark : logoLight}
          alt="Mailander logo"
          small={small}
          data-testid="onboarding-logo-img"
        />
      </LogoWrapper>
    </ClickableLogo>
  );
};

export const InstallWrapper: React.FC = () => {
  // Get properties from Install component metadata
  const showLogo = (Install as any).showLogo ?? true;
  const smallLogo = (Install as any).smallLogo ?? false;
  const background = (Install as any).background ?? 'linear-gradient(180deg, #222327 0%, #1A1A1C 100%);';
  const fill = false;
  const containerAlign = (Install as any).containerAlign ?? 'flex-start';
  const containerJustify = (Install as any).containerJustify ?? 'flex-start';
  const isLight = false;

  return (
    <Wrapper bg={background} $fill={fill} data-testid="install-wrapper">
      {showLogo && <ShellLogo isLight={isLight} small={smallLogo} />}

      <Container
        $align={containerAlign}
        $justify={containerJustify}
        data-testid="install-container"
      >
        <Install goNext={() => {}} goPrev={() => {}} goTo={() => {}} stepIndex={0} />
      </Container>
    </Wrapper>
  );
};
